module.exports = __webpack_public_path__ + "img/c04_unittechbatteringramchampion_Normal_ua.4764c487.webp";